import React from "react";

/**
 * @param {object} props
 * @param {string} [props.brandLine]
 * @param {string} [props.metaLine]
 * @param {string} [props.version]
 * @param {React.ReactNode} [props.extra]
 * @param {string} [props.testId]
 */
export function GsdAppFooter({ brandLine, metaLine, version, extra, testId = "gsd-app-footer" }) {
  return (
    <footer className="gsd-app-footer" data-testid={testId}>
      {extra}
      <div className="gsd-app-footer__inner">
        {brandLine ? <p className="gsd-app-footer__brand">{brandLine}</p> : null}
        {metaLine ? (
          <p className="gsd-app-footer__meta">
            {metaLine}
            {version ? (
              <>
                {" "}
                · <span data-testid="gsd-app-version-footer">v{version}</span>
              </>
            ) : null}
          </p>
        ) : null}
      </div>
    </footer>
  );
}
